import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

import request from 'request-promise-native';

import Modal from 'react-responsive-modal';

import ProgressBar from 'react-bootstrap/lib/ProgressBar';
import TopBar from './components/TopBar';
import Login from './components/Login';
import Register from './components/Register';
import DevicesTab from './components/tabs/DevicesTab';
import CardsTab from './components/tabs/CardsTab';
import ForgotPassword from "./components/ForgotPassword";
import PasswordReset from "./components/PasswordReset";
import SettingsTab from "./components/tabs/SettingsTab";
import PackagesTab from "./components/tabs/PackagesTab";
import RecipesTab from "./components/tabs/RecipesTab";
import UsersTab from "./components/tabs/UsersTab";

class App extends Component {

    constructor() {
        super();
        this.state = {
            resetPassword: false,
            forgotPassword: false,
            register: false,
            login: true,
            tab: 1
        };

        this.queryDict = {}
        window.location.search.substr(1).split("&").forEach(function(item) {
            this.queryDict[item.split("=")[0]] = item.split("=")[1]
        }.bind(this));
        console.log("Query dict:",this.queryDict);

        if(this.queryDict['page']==='passwordreset'){
            this.state.resetPassword=true;

            window.history.replaceState({},"","/");
            return;
        }

        if(this.queryDict['page']==='register' && this.queryDict['rid']!=null){
            this.state.register=true;
            this.state.rid = this.queryDict['rid'];

            window.history.replaceState({},"","/");
            return;
        }

        console.log("globalConfig: "+localStorage.getItem("globalConfig"));

        const globalConfStr = localStorage.getItem("globalConfig");

        let globalConfig = null;
        if(globalConfStr!==null && globalConfStr!==undefined && globalConfStr!=="undefined") {
            try {
                globalConfig = JSON.parse(globalConfStr);
            } catch (err) {
                console.log("Error parsing JSON global config");
            }
        }
        const access_code = localStorage.getItem("access_code");
        const admin = localStorage.getItem("admin")==="true";
        console.log('Stored access code: '+access_code);
        if(access_code!=null) {
            this.state.login = false;
            this.state.access_code = access_code;
            this.state.globalConfig = globalConfig;
            this.state.admin = admin;
            this.loggedIn(access_code, globalConfig, admin);
        }
    }

    logout() {
        this.setState({
            login: true,
            access_code: null,
            cardRes: false,
            devRes: false
        });
        localStorage.removeItem("access_code");
        localStorage.removeItem("globalConfig");
        localStorage.removeItem("admin");
    }

    loggedIn(access_code, globalConfig, admin) {
        this.setState({
            login: false,
            access_code: access_code,
            globalConfig: globalConfig,
            admin
        });
        //Send request to ms azure
        //this.loadCards(this,access_code);
        //this.loadDevices(this,access_code);

        localStorage.setItem("access_code", access_code);
        localStorage.setItem("admin", admin);
        localStorage.setItem("globalConfig", JSON.stringify(globalConfig));
    }

    /*async loadCards(th,access_code) {

        const options = {
            method: 'POST',
            uri: GET_CARD_LIST,
            body: {
                access_code: access_code
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode!=200) {
            console.log('Logging out!');
            this.logout();
            return;
        }

        th.setState({cards:response.body});

        console.log("Cards request success");

        th.setState({cardRes:true});

    }*/

    /*async loadDevices(th,access_code) {

        const options = {
            method: 'POST',
            uri: GET_DEVICE_LIST,
            body: {
                access_code: access_code
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode!=200) {
            console.log('Logging out!');
            this.logout();
            return;
        }

        th.setState({devices:response.body});

        console.log("Device request success");

        th.setState({devRes:true});

    }

    deviceAdded(dev) {
        const devs = this.state.devices;
        devs.push(dev);
        this.setState({
            devices: devs
        });
    }

    deviceRemoved(dev) {
        const devs = this.state.devices;
        for(let i=0;i<devs.length;i++) {
            if(dev.id===devs[i].id) {
                devs.splice(i,1);
                break;
            }
        }
        this.setState({
            devices: devs
        });
    }
    */

/*    cardAdded(prj) {
        const prjs = this.state.cards;
        prjs.push(prj);
        this.setState({
            cards: prjs
        });
    }

    cardRemoved(prj) {
        const prjs = this.state.cards;
        for(let i=0;i<prjs.length;i++) {
            if(prj.id===prjs[i].id) {
                prjs.splice(i,1);
                break;
            }
        }
        this.setState({
            cards: prjs
        });
    }
*/

    setGlobalConfig(globalConfig) {
        this.setState({
            globalConfig: globalConfig
        });
        localStorage.setItem("globalConfig", JSON.stringify(globalConfig));
    }

    register() {
        this.setState({
            register: true
        });
    }

    forgotPassword() {
        this.setState({
            forgotPassword: true
        });
    }

    render() {
        if(this.state.resetPassword) {
            return (
                <PasswordReset login={() => this.setState({resetPassword: false})} params={this.queryDict}/>
            );
        }

        if(this.state.forgotPassword) {
            return (
                <ForgotPassword login={() => this.setState({forgotPassword: false})}/>
            );
        }
        if(this.state.register) {
            return (
                <Register login={() => this.setState({register: false})} rid={this.state.rid}/>
            );
        }
        if(this.state.login) {
            return (
                <Login onLogin={this.loggedIn.bind(this)} register={this.register.bind(this)} forgotPassword={this.forgotPassword.bind(this)}/>
            );
        }

        let style1 = "sidebar-item";
        let style2 = "sidebar-item";
        let style3 = "sidebar-item";
        let style4 = "sidebar-item";
        let style5 = "sidebar-item"
        let style6 = "sidebar-item";

        if(this.state.tab===1) style1+=" selected";
        if(this.state.tab===2) style2+=" selected";
        if(this.state.tab===3) style3+=" selected";
        if(this.state.tab===4) style4+=" selected";
        if(this.state.tab===5) style5+=" selected";
        if(this.state.tab===6) style6+=" selected";

        let content = null;

        switch (this.state.tab) {
            case 1:
                content = (
                    <DevicesTab  access_code={this.state.access_code}
                                 logout={this.logout.bind(this)}
                                 currency={this.state.globalConfig==null ? "CHF" : this.state.globalConfig.currency==null ? "CHF" : this.state.globalConfig.currency}
                                 admin={this.state.admin}
                                 />
                );
                break;
            case 2:
                content = (
                    <RecipesTab access_code={this.state.access_code}
                              globalConfig={this.state.globalConfig}
                              currency={this.state.globalConfig==null ? "CHF" : this.state.globalConfig.currency==null ? "CHF" : this.state.globalConfig.currency}
                              logout={this.logout.bind(this)}/>
                );
                break;
            case 3:
                content = (
                    <CardsTab access_code={this.state.access_code}
                              globalConfig={this.state.globalConfig}
                              currency={this.state.globalConfig==null ? "CHF" : this.state.globalConfig.currency==null ? "CHF" : this.state.globalConfig.currency}
                                 logout={this.logout.bind(this)}/>
                );
                break;
            case 4:
                content = (
                    <SettingsTab globalConfig={this.state.globalConfig}
                                 setGlobalConfig={this.setGlobalConfig.bind(this)}
                                 access_code={this.state.access_code}
                                 logout={this.logout.bind(this)}/>
                );
                break;
            case 5:
                content = (
                    <PackagesTab/>
                );
                break;
            case 6:
                content = (
                    <UsersTab globalConfig={this.state.globalConfig}
                                 access_code={this.state.access_code}
                                 logout={this.logout.bind(this)}/>
                );
                break;
        }
        return (
            <div>
                <TopBar logout={this.logout.bind(this)}/>
                <div>
                    <aside className="left-sidebar" data-sidebarbg="skin5">
                        <div className="scroll-sidebar">
                            <nav className="sidebar-nav">
                                <ul id="sidebarnav" className="p-t-30">
                                    <li className={style1}><a onClick={() => this.setState({tab: 1})}
                                                              className="sidebar-link waves-effect waves-dark sidebar-link"
                                                              href="javascript:void(0);" aria-expanded="false"><i
                                        className="mdi mdi-book"></i><span className="hide-menu">Vending machines</span></a>
                                    </li>
                                    <li className={style2}><a onClick={() => this.setState({tab: 2})}
                                                              className="sidebar-link waves-effect waves-dark sidebar-link"
                                                              href="javascript:void(0);" aria-expanded="false"><i
                                        className="mdi mdi-receipt"></i><span className="hide-menu">Recipes</span></a>
                                    </li>
                                    <li className={style3}><a onClick={() => this.setState({tab: 3})}
                                                              className="sidebar-link waves-effect waves-dark sidebar-link"
                                                              href="javascript:void(0);" aria-expanded="false"><i
                                        className="mdi mdi-credit-card"></i><span className="hide-menu">Cards</span></a>
                                    </li>
                                    <li className={style4}><a onClick={() => this.setState({tab: 4})}
                                                              className="sidebar-link waves-effect waves-dark sidebar-link"
                                                              href="javascript:void(0);" aria-expanded="false"><i
                                        className="mdi mdi-settings"></i><span className="hide-menu">Settings</span></a>
                                    </li>
                                    <li className={style5}><a onClick={() => this.setState({tab: 5})}
                                                              className="sidebar-link waves-effect waves-dark sidebar-link"
                                                              href="javascript:void(0);" aria-expanded="false"><i
                                        className="mdi mdi-package"></i><span className="hide-menu">Packages</span></a>
                                    </li>
                                    {this.state.admin ? (
                                        <li className={style6}><a onClick={() => this.setState({tab: 6})}
                                                                  className="sidebar-link waves-effect waves-dark sidebar-link"
                                                                  href="javascript:void(0);" aria-expanded="false"><i
                                            className="mdi mdi-group"></i><span className="hide-menu">Users</span></a>
                                        </li>
                                    ) : ""}
                                </ul>
                            </nav>
                        </div>
                    </aside>
                </div>

                {content}
            </div>
        );
    }
}

export default App;
